import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'PediGymWaiverApp';  // Add this line if missing

  ngOnInit(): void {
    /*
    this.toastOpts = {
      visible: true,
      message: 'No personal information is collected or stored',
      msgType: 'info',
      at: 'top',
      my: 'top',
      offset: '0 140',
      displayTime: 5000,
    };
    */
  }




}
